require('./angulartics-ga')
module.exports = 'angulartics.google.analytics'
